import React, { FC } from "react";
import FunnelAnalysis from "../components/FunnelAnalysis";

const Funnel: FC = () => {
  return (
    <div style={{ padding: "24px" }}>
      <FunnelAnalysis />
    </div>
  );
};

export default Funnel;
